//* Libraries imports
import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  PlusIcon,
  Search,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "lucide-react";
import { AttachFile } from "@mui/icons-material";

//* Componentes imports
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { DataTable } from "@/components/ui";

type PecasSectionProps = {
  pecas: any;
  activity: any;
  handleFieldChange: (field: string, value: any) => void;
  techinicals: any[];
  categories: any[];
};

export const PecasSection = ({
  pecas,
  activity,
  handleFieldChange,
  techinicals,
  categories,
}: PecasSectionProps) => {
  const [search, setSearch] = useState("");
  const [showModalAddTechnical, setShowModalAddTechnical] = useState(false);
  const [selectTypeModal, setSelectTypeModal] = useState("category");
  const [selectedCategoryTechnical, setSelectedCategoryTechnical] =
    useState("");

  const handleAddTechnical = async (_field: string, technical: string) => {
    if (technical == "new_document") {
      // Implement logic for new document if needed
    } else {
      let technical_file = techinicals.filter(
        (item: any) => item._id == technical
      )[0];
      let techinicals_ = { ...pecas };
      techinicals_[technical] = technical_file;
      handleFieldChange("techinicals", techinicals_);
    }
  };

  return (
    <section className="flex flex-col w-full items-start rounded-xl">
      {showModalAddTechnical == true && (
        <Dialog
          maxWidth="lg"
          fullWidth
          open={showModalAddTechnical}
          onClose={() => {
            setSelectTypeModal("category");
            setSelectedCategoryTechnical("");
            setShowModalAddTechnical(false);
          }}
        >
          <DialogTitle>
            <h1 className="text-2xl font-bold mb-6">
              Adicionar e vincular peças técnicas
            </h1>
            <IconButton
              aria-label="close"
              onClick={() => {
                setSelectTypeModal("category");
                setSelectedCategoryTechnical("");
                setShowModalAddTechnical(false);
              }}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div
              className="grid grid-cols-2"
              style={{
                padding: 10,
                backgroundColor: "#f2f2f2",
                margin: 2,
                height: "50vh",
              }}
            >
              <div
                className="scrollbar-hide"
                style={{
                  backgroundColor: "white",
                  borderRadius: 10,
                  position: "relative",
                  margin: 2,
                  height: "100%",
                  overflow: "scroll",
                }}
              >
                <div
                  style={{
                    background: "url(/pontilhado.png)",
                    position: "absolute",
                    zIndex: 1,
                    top: 20,
                    height: 110,
                    width: 100,
                    left: -82,
                    objectFit: "contain",
                    backgroundRepeat: "repeat-y",
                    backgroundSize: "262px 50px",
                  }}
                ></div>
                <div style={{ padding: 5 }}>
                  <p
                    style={{ display: "flex", alignItems: "center", zIndex: 2 }}
                  >
                    <svg
                      id="products-img1"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginRight: 5 }}
                      width={18}
                      height="18"
                      viewBox="0 0 15 20"
                    >
                      <path
                        d="M0.662897 3.35419C0.220942 3.81256 0 4.36119 0 4.99998L0 13.6666C0 14.3057 0.220942 14.8543 0.662897 15.3125C1.10489 15.771 1.63392 16 2.24999 16H2.89279V2.66658H2.24999C1.63378 2.66658 1.10478 2.89582 0.662897 3.35419Z"
                        fill="#7D8592"
                      />
                      <path
                        d="M12.8571 0.999959C12.8571 0.722158 12.7634 0.486097 12.5758 0.291629C12.3885 0.097161 12.1607 0 11.8929 0L6.10719 0C5.83938 0 5.61172 0.097161 5.42417 0.291629C5.23665 0.485987 5.14292 0.722122 5.14292 0.999959V2.66658H3.8572V16H14.1429V2.66658H12.8571V0.999959ZM11.5715 2.66658H6.42861V1.33329H11.5715V2.66658Z"
                        fill="#7D8592"
                      />
                      <path
                        d="M17.3371 3.35419C16.8951 2.89586 16.366 2.66658 15.75 2.66658H15.1071V16H15.75C16.3661 16 16.8951 15.771 17.3371 15.3125C17.779 14.8543 18 14.3056 18 13.6666V4.99998C18 4.36119 17.7789 3.81256 17.3371 3.35419Z"
                        fill="#7D8592"
                      />
                    </svg>{" "}
                    {activity?.name || "Atividade"}
                  </p>

                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 30,
                      zIndex: 2,
                    }}
                  >
                    <svg
                      id="atividades-img"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginRight: 5 }}
                      width={18}
                      height="18"
                      viewBox="0 0 15 20"
                    >
                      <path
                        d="M17.6307 0.00157104C14.117 -0.0614313 10.1098 1.77539 7.57338 4.62475C5.14943 4.6705 2.78923 5.66429 1.05152 7.4021C0.950272 7.50185 0.914273 7.65111 0.958522 7.78612C1.00352 7.92187 1.12052 8.02012 1.26152 8.04037L4.15195 8.45439L3.79496 8.85416C3.66221 9.00266 3.66896 9.22842 3.80996 9.36943L8.6301 14.1899C8.70285 14.2626 8.79885 14.2994 8.8956 14.2994C8.98485 14.2994 9.07409 14.2679 9.14534 14.2041L9.54508 13.8471L9.95907 16.7377C9.97932 16.8787 10.0903 16.9822 10.2246 17.0272C10.2591 17.0385 10.2951 17.0437 10.3318 17.0437C10.4383 17.0437 10.5471 16.9972 10.6221 16.923C12.3358 15.2091 13.3295 12.8488 13.3752 10.4247C16.2274 7.88287 18.0791 3.87697 17.9974 0.367585C17.9921 0.168077 17.8309 0.00682124 17.6307 0.00157104ZM14.1747 6.47582C13.8095 6.84108 13.3295 7.02409 12.8488 7.02409C12.368 7.02409 11.888 6.84108 11.5228 6.47582C10.7923 5.74454 10.7923 4.55499 11.5228 3.82372C12.254 3.09244 13.4435 3.09244 14.1747 3.82372C14.906 4.55499 14.906 5.74529 14.1747 6.47582Z"
                        fill="#7D8592"
                      />
                      <path
                        d="M2.043 12.6785C1.24052 13.4811 0.13879 17.1067 0.0157927 17.517C-0.0239564 17.649 0.0127928 17.7922 0.109541 17.8897C0.181539 17.9618 0.276787 18 0.375035 18C0.411034 18 0.447033 17.9948 0.483032 17.9843C0.893273 17.8612 4.51869 16.7595 5.32118 15.9569C6.22491 15.0531 6.22491 13.5823 5.32118 12.6785C4.4167 11.7748 2.94673 11.7755 2.043 12.6785Z"
                        fill="#7D8592"
                      />
                    </svg>{" "}
                    <b>Peças Técnicas ({Object.values(pecas).length})</b>
                  </p>
                </div>

                <div
                  key={0}
                  style={{
                    textOverflow: "ellipsis",
                    padding: 5,
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      color: "#1777CF",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>1. {activity?.name}</span>{" "}
                    <span>{Object.values(pecas).length}</span>
                  </p>
                  <Separator style={{ borderWidth: 0.5, marginTop: 5 }} />
                </div>
              </div>
              <div
                className="scrollbar-hide"
                style={{
                  backgroundColor: "white",
                  borderRadius: 10,
                  position: "relative",
                  padding: 10,
                  margin: 2,
                  height: "100%",
                  overflow: "scroll",
                }}
              >
                <div style={{ display: "flex" }}>
                  <div
                    onClick={(_e) => {
                      setSelectTypeModal("category");
                    }}
                    style={{
                      width: "50%",
                      height: 40,
                      borderRadius: 5,
                      border: "1px solid #f2f2f2",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      background:
                        selectTypeModal == "category" ? "#1777CF" : "white",
                      color:
                        selectTypeModal == "category" ? "white" : "#1777CF",
                    }}
                  >
                    Categorias
                  </div>
                  <div
                    onClick={(e) => {
                      if (!selectedCategoryTechnical) {
                        return;
                      }
                      setSelectTypeModal("document");
                    }}
                    style={{
                      width: "50%",
                      height: 40,
                      borderRadius: 5,
                      border: "1px solid #f2f2f2",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      background:
                        selectTypeModal == "document" ? "#1777CF" : "white",
                      color:
                        selectTypeModal == "document" ? "white" : "#1777CF",
                    }}
                  >
                    Peças Técnicas
                  </div>
                </div>

                {selectTypeModal == "category" && (
                  <div>
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: 15,
                        zIndex: 2,
                        marginBottom: 2,
                      }}
                    >
                      <b>
                        Categorias (
                        {
                          categories.filter(
                            (item: any) => item.type == "techinical"
                          ).length
                        }
                        )
                      </b>{" "}
                    </p>
                    <p style={{ fontSize: 14, marginBottom: 10 }}>
                      Peças Técnicas: {Object.values(pecas).length}/
                      {techinicals.length}
                    </p>
                    {categories
                      .filter((item: any) => item.type == "techinical")
                      .map((activity: any, index: any) => (
                        <div
                          key={index}
                          style={{
                            textOverflow: "ellipsis",
                            padding: 5,
                            cursor: "pointer",
                            border: "1px solid #f2f2f2",
                            borderRadius: 5,
                          }}
                          onClick={(e) => {
                            setSelectedCategoryTechnical(activity._id);
                          }}
                        >
                          <p
                            style={{
                              color:
                                activity._id == selectedCategoryTechnical
                                  ? "#1777CF"
                                  : "rgba(0, 0, 0, 0.87)",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>{activity.name}</span>{" "}
                            <span>
                              {
                                Object.values(pecas).filter(
                                  (item: any) => item.category == activity._id
                                ).length
                              }
                              /
                              {
                                techinicals.filter(
                                  (item: any) => item.category == activity._id
                                ).length
                              }
                            </span>
                          </p>
                        </div>
                      ))}
                  </div>
                )}

                {selectTypeModal == "document" && (
                  <div style={{ marginTop: 15 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 10,
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          padding: 2,
                          borderRadius: 5,
                          border: "1px solid #f2f2f2",
                          fontSize: 15,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                        onClick={(e) => {
                          let index = categories
                            .filter((item: any) => item.type == "techinical")
                            .map((item: any, indexc: any) => {
                              if (item._id == selectedCategoryTechnical) {
                                return indexc;
                              }
                              return -1;
                            })
                            .filter((item: any) => item != -1)[0];
                          if (index == 0) {
                            return;
                          }
                          setSelectedCategoryTechnical(
                            categories.filter(
                              (item: any) => item.type == "techinical"
                            )[index - 1]._id
                          );
                        }}
                      >
                        <ChevronLeftIcon />
                      </div>
                      <div
                        style={{
                          padding: 2,
                          borderRadius: 5,
                          border: "1px solid #f2f2f2",
                          fontSize: 15,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                      >
                        {categories
                          .filter((item: any) => item.type == "techinical")
                          .map((item: any, indexc: any) => {
                            if (item._id == selectedCategoryTechnical) {
                              return indexc;
                            }
                            return -1;
                          })
                          .filter((item: any) => item != -1)[0] + 1}
                        /
                        {
                          categories.filter(
                            (item: any) => item.type == "techinical"
                          ).length
                        }
                      </div>
                      <div
                        style={{
                          cursor: "pointer",
                          padding: 2,
                          borderRadius: 5,
                          border: "1px solid #f2f2f2",
                          fontSize: 15,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                        onClick={(e) => {
                          let index = categories
                            .filter((item: any) => item.type == "techinical")
                            .map((item: any, indexc: any) => {
                              if (item._id == selectedCategoryTechnical) {
                                return indexc;
                              }
                              return -1;
                            })
                            .filter((item: any) => item != -1)[0];
                          if (
                            index ==
                            categories.filter(
                              (item: any) => item.type == "techinical"
                            ).length -
                              1
                          ) {
                            return;
                          }
                          setSelectedCategoryTechnical(
                            categories.filter(
                              (item: any) => item.type == "techinical"
                            )[index + 1]._id
                          );
                        }}
                      >
                        <ChevronRightIcon />
                      </div>
                    </div>

                    <p
                      style={{
                        marginBottom: 10,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {
                          categories
                            .filter((item: any) => item.type == "techinical")
                            .filter(
                              (item: any) =>
                                item._id == selectedCategoryTechnical
                            )[0]?.name
                        }
                      </span>{" "}
                      <span>
                        {
                          Object.values(pecas).filter(
                            (item: any) =>
                              item.category == selectedCategoryTechnical
                          ).length
                        }
                        /
                        {
                          techinicals.filter(
                            (item: any) =>
                              item.category == selectedCategoryTechnical
                          ).length
                        }
                      </span>{" "}
                    </p>
                    <Separator style={{ borderWidth: 0.5, marginTop: 5 }} />

                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: 15,
                        zIndex: 2,
                        marginBottom: 10,
                      }}
                    >
                      <b>
                        Peças Técnicas (
                        {
                          Object.values(pecas).filter(
                            (item: any) =>
                              item.category == selectedCategoryTechnical
                          ).length
                        }
                        /
                        {
                          techinicals.filter(
                            (item: any) =>
                              item.category == selectedCategoryTechnical
                          ).length
                        }
                        )
                      </b>{" "}
                    </p>
                    {[
                      ...techinicals.filter(
                        (item: any) =>
                          item.category == selectedCategoryTechnical
                      ),
                    ].map((activity: any, index: any) => (
                      <div
                        key={index}
                        style={{
                          textOverflow: "ellipsis",
                          padding: 5,
                          cursor: "pointer",
                          border: "1px solid #f2f2f2",
                          borderRadius: 5,
                        }}
                        onClick={(e) => {
                          if (pecas[activity._id]) {
                            let documents_: any = {
                              ...pecas,
                            };
                            delete documents_[activity._id];
                            handleFieldChange("techinicals", documents_);
                          } else {
                            handleAddTechnical("techinicals", activity._id);
                          }
                        }}
                      >
                        <p
                          style={{
                            color: pecas[activity._id]
                              ? "#1777CF"
                              : "rgba(0, 0, 0, 0.87)",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{activity.name}</span>{" "}
                          <span>
                            <AttachFile />
                          </span>
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}

      {/* Header */}
      <Card className="w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] ">
          <div className="flex w-full h-9 items-center justify-between mb-5">
            <h1 className="text-xl font-bold" id="atividades">
              Peças Técnicas ({Object.values(pecas).length})
            </h1>

            <div className="flex items-center gap-5">
              <Button
                size="icon"
                className="w-[30px] h-[30px] bg-blue-500 rounded-lg"
                onClick={() => setShowModalAddTechnical(true)}
              >
                <PlusIcon className="h-4 w-4 text-white" />
              </Button>
            </div>
          </div>

          <div className="mb-4 flex w-full" style={{ position: "relative" }}>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder="Pesquisar"
              className="p-2 border rounded"
              style={{
                width: "-webkit-fill-available",
                borderRadius: 20,
                paddingLeft: 40,
              }}
            />
            <Search
              style={{
                position: "absolute",
                top: "20%",
                left: 10,
                color: "grey",
              }}
            />
          </div>

          <div className="w-full">
            <DataTable
              hide_search
              hide_add
              hideEdit
              columns={[
                {
                  image: "photoUrl",
                  placeholderImage: "/documents.svg",
                  style_image: {
                    borderRadius: 10,
                    background: "rgb(244, 244, 244)",
                    width: 30,
                    height: 30,
                    objectFit: "contain",
                  },
                  key: "name",
                  header: "Nome",
                  render: (value: any) => String(value || ""),
                },
              ]}
              hide_header
              data={
                Object.values(pecas)?.filter((item: any) =>
                  item.name?.toLowerCase().includes(search.toLowerCase())
                ) ?? []
              }
              basePath="techinicals"
              onDelete={(e) => {
                let documents_: any = { ...pecas };
                delete documents_[e];
                handleFieldChange("techinicals", documents_);
              }}
              newFormat
            />
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
